/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank0 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9.21 11.957c0 1.226.237 2.16.71 2.8.473.64 1.167.96 2.08.96s1.607-.32 2.08-.96.71-1.574.71-2.8c0-1.214-.233-2.127-.7-2.74-.467-.62-1.163-.93-2.09-.93s-1.623.31-2.09.93c-.467.613-.7 1.526-.7 2.74zm3.89 1.4c-.087.366-.223.64-.41.82-.18.18-.41.27-.69.27s-.51-.09-.69-.27-.317-.454-.41-.82c-.087-.374-.13-.84-.13-1.4 0-.554.043-1.007.13-1.36.087-.354.22-.614.4-.78a.99.99 0 0 1 .7-.26c.287 0 .52.086.7.26.18.166.313.426.4.78.087.353.13.806.13 1.36 0 .56-.043 1.026-.13 1.4z" />
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank0 as Rank0 };
